<!-- eslint-disable -->
<template lang="pug">
    game-preview-settings(v-if="settings")
        game-preview-setting
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_game') }}
            span(slot="value") {{ $i18n.t('common.common_gameName_multiplicationAndDivision') }}
        game-preview-setting
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_mode') }}
            span(slot="value") {{ $i18n.t('trainer')[parameters.mode] }}
        game-preview-setting
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_numOfExamples') }}
            span(slot="value") {{ settings.amountOfExamples }}
        game-preview-setting(v-if="settings.timeForAnswer != '-1'")
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_timeToAnswer') }}
            span(slot="value")
                | {{ settings.timeForAnswer }} {{ $i18n.t('trainer.trainer_gameFormSettingValue_seconds') }}
        template(v-if="settings.numbers.length !== 0")
            game-preview-setting
                span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_numbers') }}
                span(slot="value") {{ settings.numbers.join(', ') }}
            game-preview-setting(v-if="!settings.tabulatedValue")
                span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_divisibleMultiplier') }}
                span(slot="value") {{ digitCapacity[settings.digitCapacity.right.join()] }}
            game-preview-setting
                span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_tableValue') }}
                span(slot="value")
                    template(v-if="settings.tabulatedValue")
                        | {{ $i18n.t('trainer.trainer_gameFormSettingValue_onAbbreviated') }}
                    template(v-else)
                        | {{ $i18n.t('trainer.trainer_gameFormSettingValue_offAbbreviated') }}
        template(v-else)
            game-preview-setting
                span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_divisibleMultiplier') }}
                span(slot="value") {{ digitCapacity[settings.digitCapacity.left.join()] }}
            template(v-if="parameters.fractions && parameters.fractions.left")
                game-preview-setting
                    span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_fractions') }}
                    span(slot="value") {{ $i18n.t('trainer.trainer_gameFormSettingValue_on') }}
                game-preview-setting
                    span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_numbersAfterPoints') }}
                    span(slot="value") {{ parameters.fractionalPart.left }}
            game-preview-setting
                span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_dividerMultiplier') }}
                span(slot="value") {{ digitCapacity[settings.digitCapacity.right.join()] }}
            template(v-if="parameters.fractions && parameters.fractions.right")
                game-preview-setting
                    span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_fractions') }}
                    span(slot="value") {{ $i18n.t('trainer.trainer_gameFormSettingValue_on') }}
                game-preview-setting
                    span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_numbersAfterPoints') }}
                    span(slot="value") {{ parameters.fractionalPart.right }}
        game-preview-setting
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_operations') }}
            span(slot="value") {{ field('operations') }}
        game-preview-setting(v-if="parameters.divMode")
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSettingDivision_mode') }}
            span(slot="value") {{ $i18n.t(`trainer.trainer_gameFormSettingDivision_${parameters.divMode}`) }}
        game-preview-setting
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_answers') }}
            span(slot="value") {{ answers }}
        template(v-if="settings.dictation")
            game-preview-setting
                span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_dictation') }}
                span(slot="value") {{ $i18n.t('trainer.trainer_gameFormSettingValue_on') }}
</template>

<script>
    /*eslint-disable*/
    import preview from '../../../utils/multiplication-and-division/preview'
    import GamePreviewSettings from './GamePreviewSettings.vue'
    import GamePreviewSetting from './GamePreviewSetting.vue'

    export default {
        props: ['parameters', 'exerciseId', 'type'],
        mixins: [preview],
        components: {
            GamePreviewSettings,
            GamePreviewSetting
        },
        computed: {
            answers() {
                if (this.parameters.positiveAnswers && this.parameters.negativeAnswers) {
                    return this.$i18n.t('trainer.trainer_gameFormSetting_answersAny');
                }
                if (this.parameters.positiveAnswers) {
                    return this.$i18n.t('trainer.trainer_gameFormSetting_answersOnlyPositive');
                }
                if (this.parameters.negativeAnswers) {
                    return this.$i18n.t('trainer.trainer_gameFormSetting_answersOnlyNegative');
                }
            },
        }
    }
</script>
